<template>
<b-container class="px-0">
    <b-row class="justify-content-md-center">
        <b-col cols=12>
            <b-card no-body tag="h1" class="border-0 pt-3 pb-3 bg-transparent">{{pageTitle}}
            </b-card>
        </b-col>
    </b-row>

    <b-row class="justify-content-md-center">
        <b-col cols=12>
            <img usemap="#image-map" src="@/assets/hartalocalitatijudarad.png" class="lmap">

            <map name="image-map">
                <area v-for="loc in localHarta.area" :key="loc.id" :title="loc['@title']" :alt="loc['@alt']" :coords="loc['@coords']" :shape="loc['@shape']" :href="loc['@href']" :target="loc['@target']">
            </map>

        </b-col>
    </b-row>

    <b-row>
        <b-col cols=12>
            <b-card class="px-1 my-4 pb-4 border-white bg-transparent">
                <b-card-title title-tag="h3">{{infoHarta}}</b-card-title>
                <b-card-text class="text-center">
                    Pentru afișarea monografiilor unei localități/comune,
                    faceți click pe suprafața din interiorul granițelor
                    respectivei localități/comune.
                </b-card-text>
            </b-card>
        </b-col>
    </b-row>
</b-container>
</template>

<script>
import ImageMap from "image-map";
ImageMap('img[usemap]');

import localitati from '@/assets/localitati.json';

export default {
    data() {
        return {
            pageTitle: "Harta cu monografii",
            infoHarta: "Cum se folosește",
            localHarta: localitati,
            ref: false
        };
    },
    created() {
        var script = document.createElement("script");
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/image-map-resizer/1.0.10/js/imageMapResizer.min.js';
        document.body.appendChild(script);
        var x = document.createElement("SCRIPT");
        var t = document.createTextNode("setInterval(function(){imageMapResize();}, 1000);");
        x.type = "text/javascript";
        x.appendChild(t);
        document.body.appendChild(x);

    },
    methods: {
        forceRerender() {
            if (this.ref == false) {
                location.reload();
            }
        }
    },
    updated: function () {
        this.$nextTick(function () {
            setTimeout(function () {
                console.log('rendered');
            }, 100);
        })
    },
    watch: {
        '$route': '/harta'
    },
}
</script>

<style lang="scss" scoped>
.lmap {
    display: block;
    max-width: 100%;
    height: auto;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
}

.dark {
    .lmap {
        background-color: $white;
    }
}
</style>
